module.exports = __webpack_public_path__ + "img/AvgTimeExceededSmiley.9ecee688.svg";